const dictionary = {
    pt: {
        messages: {
            cpf: () => 'CPF inválido',
            required: () => 'O campo é obrigatório.',
            email: () => 'E-mail inválido',
            numeric: () => 'Por favor, digite um número',
            confirmed: () => 'Confirmação inválida',
            url: () => 'URL inválida',
            regex: () => 'O valor digitado tem o formato inválido',
            min: () => 'Muito curto'
        }
    }
}
export default dictionary
